import React, { useEffect, useRef } from 'react';
import './MarcosSucesso.css';

const marcos = [
  {
    ano: '2010',
    titulo: 'Funda\u00e7\u00e3o MSA Porta Paletes',
    descricao:
      'In\u00edcio das atividades da MSA, com foco em solu\u00e7\u00f5es de armazenagem e compromisso com qualidade e atendimento pr\u00f3ximo ao cliente.',
    foto: '/sobre-nos/image6.avif',
    lado: 'esquerdo', // texto esquerda, imagem direita
  },
  {
    ano: '2014',
    titulo: 'Estrutura\u00e7\u00e3o da Produ\u00e7\u00e3o',
    descricao:
      'Expans\u00e3o da capacidade produtiva e padroniza\u00e7\u00e3o dos processos industriais, garantindo mais efici\u00eancia e consist\u00eancia.',
    foto: '/sobre-nos/image7.avif',
    lado: 'direito', // imagem esquerda, texto direita
  },
  {
    ano: '2018',
    titulo: 'Consolida\u00e7\u00e3o no Mercado',
    descricao:
      'Reconhecimento regional como refer\u00eancia em estruturas met\u00e1licas para armazenagem, ampliando a carteira de clientes em todo o Centro-Oeste.',
    foto: '/sobre-nos/image8.avif',
    lado: 'esquerdo',
  },
  {
    ano: '2022',
    titulo: 'Modernização',
    descricao:
      'Investimento em tecnologia, melhoria nos acabamentos e otimização dos processos de fabricação.',
    foto: '/sobre-nos/image8.avif',
    lado: 'esquerdo',
  },
  {
    ano: 'Hoje',
    titulo: 'Sustentabilidade Industrial',
    descricao:
      'Referência em soluções de armazenagem, a MSA segue evoluindo, inovando e entregando resultados que impulsionam a operação dos seus clientes.',
    foto: '/sobre-nos/image9.avif',
    lado: 'direito',
  },
];

function MarcosSucesso() {
  const titleRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Bidirecional: adiciona ao entrar, remove ao sair
          if (entry.isIntersecting) {
            entry.target.classList.add('ms__visible');
          } else {
            entry.target.classList.remove('ms__visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    itemRefs.current.forEach((el) => { if (el) observer.observe(el); });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="ms">
      <div className="ms__container">
        <h2 className="ms__title ms__fade" ref={titleRef}>
          Marcos de Sucesso
        </h2>

        <div className="ms__timeline">
          {/* Linha vertical central */}
          <div className="ms__linha" />

          {marcos.map((marco, i) => (
            <div
              key={marco.ano}
              className={`ms__item ms__item--${marco.lado}`}
              ref={(el) => (itemRefs.current[i] = el)}
            >
              {/* Coluna de texto */}
              <div className="ms__texto">
                <span className="ms__ano">{marco.ano}</span>
                <h3 className="ms__subtitulo">{marco.titulo}</h3>
                <p className="ms__desc">{marco.descricao}</p>
              </div>

              {/* Ponto central na linha */}
              <div className="ms__ponto" />

              {/* Coluna de imagem */}
              <div className="ms__imagem">
                {marco.foto ? (
                  <img src={marco.foto} alt={marco.titulo} />
                ) : (
                  <div className="ms__imagem-placeholder" />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MarcosSucesso;
